import React, { useEffect } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useDictModel } from "@/views/base/dict/dictModel";
import { formatNum, momentFormat } from "@/utils/utils";
import { ISCMApplyListDetail } from "../applyListTypes";
import { useApplyListModel } from "../applyListModel";
import { globalPrompt } from "@/components/message";
import useNavModel from "@/model/navModel";
import { useApplyListDetailsModel } from "./details/applyListDetailsModel";
import { DictCodeEnmu } from '@/types/AppDictEnums'
import { useOrgModel } from '@/views/base/organization/orgModel'

export function DataTable() {
    const { getTreeNodeName } = useDictModel(() => []);
    const { getSelectedDictOne } = useDictModel(() => [])
    const {
        dataSource, selectedRowKeys, pgCfg, loading,
        loadData, setSelectedRowKeys
    } = useApplyListModel();
    const { resetEditCatch } = useApplyListDetailsModel();
    const { addNav, findNav, selectNav, switchNavState } = useNavModel(() => []);
    const { getOrgTreeSelect } = useOrgModel(() => []);

    useEffect(() => {
        loadData()
    }, [])
    const onLook = (value) => {

        let supplierEditKey = '5-1-2'
        let isFindNav = findNav(supplierEditKey)
        if (!isFindNav) {
            addNav(supplierEditKey, { id: value.id, mode: 'look' })
        } else {
            globalPrompt('modal', {
                title: '申请列表跳转详情',
                type: 'warning',
                text: '您还有申请列表详情未保存，是否跳转',
                okText: '跳转未保存页',
                onOk: () => selectNav(isFindNav ? isFindNav.id : ''),
                cancelText: '打开新页签',
                onCancel: () => {
                    switchNavState(supplierEditKey, { id: value.id, mode: 'look' })
                },
            })
        }
    }
    const columns: ColumnsType<ISCMApplyListDetail> = [
        {
            title: '序号',
            width: 50,
            align: "center",
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            title: '申请单号',
            width: 180,
            dataIndex: 'code',
            fixed: "left",
            render: (t, r) => (
                <span
                    style={{ color: '#4165E3', cursor: 'pointer' }}
                    onClick={() => { onLook(r) }}
                >
                    {t}
                </span>
            ),
        }, {
            title: '名称',
            width: 250,
            dataIndex: 'supplierName',
            fixed: "left",
        }, {
            title: '申请部门',
            width: 160,
            dataIndex: 'departmentName',
            render: (t, r) => (
                <span
                >
                    {r.typeCode !== 'assets-apply-type.transfer' ? t : r.departmentOutName}
                </span>
            ),
        }, {
            title: '申请人',
            width: 160,
            dataIndex: 'createUser',
        }, {
            title: '申请时间',
            width: 160,
            dataIndex: 'createTime',
            render: (text) => `${momentFormat(text)}`
        }, {
            title: '申请类型',
            width: 100,
            dataIndex: 'typeName',
        }, {
            title: '申请状态',
            width: 100,
            dataIndex: 'status',
            render: (text: string) => getSelectedDictOne(DictCodeEnmu.ASSETS_APPLY_STATUS).find((item) => item.value === text)?.label ?? '',

        },
    ];

    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            rowKey={record => record.id}
            loading={loading}
            rowSelection={{
                //全部选中时  (存string[])
                onSelectAll: (selected, selectedRows, changeRows) => {
                    let changeRowId = changeRows.map(item => item.id);
                    selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
                        : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
                },
                onSelect: (record) => onRow(record.id),
                selectedRowKeys: selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: (total: number) => `共${total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                },
                showSizeChanger: true
            }}
            bordered
            onRow={record => ({
                onClick: () => onRow(record.id),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.id]);
                }
            })}
            scroll={{ x: 'max-content', y: "calc(100vh - 410px)" }}
        />
    )
}
